import React from 'react';

export default () => (
  <svg width="30" height="30" viewBox="0 0 32 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.0474 24.6504L6.61556 29.9801L8.72177 19.2775L0.785034 11.8689L11.5194 10.5837L16.0474 0.674927L20.5754 10.5837L31.3097 11.8689L23.373 19.2775L25.4792 29.9801L16.0474 24.6504Z" fill="#FFC700"/>
  </svg>
);
